import { render, staticRenderFns } from "./CreateNewsAndEvents.vue?vue&type=template&id=1e37d582"
import script from "./CreateNewsAndEvents.vue?vue&type=script&lang=js"
export * from "./CreateNewsAndEvents.vue?vue&type=script&lang=js"
import style0 from "./CreateNewsAndEvents.vue?vue&type=style&index=0&id=1e37d582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports